module.exports = __webpack_public_path__ + "img/default1.11815b98.png";